import { recipesFr } from './recipes-fr';
import { batchScalingFr, processRoutingFr } from './process-routing-fr';
import { declarationsFr } from './declarations-fr';
import { analysisFr } from './analysis-fr';

export const plmFr = {
  material: {
    tab: 'Développement produit',
    roles: {
      TRADING_GOOD: 'Marchandise',
      RAW_MATERIAL: 'Matière première',
      SEMI_FINISHED: 'Produit semi-fini',
      FINISHED_GOOD: 'Produit fini',
      PACKAGING_MATERIAL: 'Matériau d’emballage',
      OPERATING_SUPPLY: 'Consommable',
      BY_PRODUCT: 'Sous-produit',
    },
    sections: {
      roles: 'Rôles d’utilisation',
      versions: 'Profils de données de base versionnés',
      translations: 'Désignations multilingues',
    },
    help: {
      roles:
        'Un article peut avoir plusieurs rôles simultanément. Les modifications sont enregistrées avec contrôle de version.',
      structuredJson:
        'Clés et valeurs structurées sous forme d’objet JSON valide. Saisir les nombres de calcul comme chaînes décimales.',
      conversions:
        'Liste JSON avec fromUnitCode, toUnitCode, factor, offset, roundingScale et usesDensity.',
      dms: 'Seuls les fichiers du dossier DMS protégé de cet article peuvent être sélectionnés.',
    },
    messages: {
      saved: 'Version des données de base enregistrée.',
      invalid: 'Les données sont invalides.',
      rolesSaved: 'Rôles enregistrés.',
      workflowUpdated: 'Workflow mis à jour.',
      submitted: 'Version soumise à validation.',
    },
    states: {
      noApproved: 'Aucune version des données de base n’est encore approuvée.',
      approvedVersion: 'Version approuvée : v{{version}}',
      empty: 'Aucune version disponible.',
      noDocuments: 'Le dossier article ne contient pas encore de fichier DMS.',
    },
    actions: {
      newVersion: 'Nouvelle version',
      submit: 'Soumettre',
      approve: 'Approuver',
      copy: 'Copier vers une nouvelle version',
      archive: 'Archiver',
      confirm: 'Confirmer',
    },
    columns: {
      version: 'Version',
      status: 'Statut',
      validity: 'Validité',
      names: 'Désignation',
      suppliers: 'Instantané fournisseurs',
    },
    statuses: {
      DRAFT: 'Brouillon',
      IN_REVIEW: 'En validation',
      APPROVED: 'Approuvé',
      SUPERSEDED: 'Remplacé',
      ARCHIVED: 'Archivé',
    },
    editor: {
      createTitle: 'Créer une version des données de base',
      editTitle: 'Modifier la version v{{version}}',
      description:
        'Les versions approuvées sont immuables. Les fournisseurs sont capturés côté serveur lors de l’enregistrement.',
    },
    fields: {
      usageRoles: 'Rôles d’utilisation',
      standardUnit: 'Unité de quantité standard',
      shelfLifeDays: 'Durée de conservation (jours)',
      density: 'Densité',
      densityUnit: 'Unité de densité',
      originCountry: 'Pays d’origine',
      originRegion: 'Région d’origine',
      manufacturer: 'Fabricant',
      manufacturerAddress: 'Adresse du fabricant',
      validFrom: 'Valide à partir du',
      validTo: 'Valide jusqu’au',
      internalName: 'Désignation interne',
      externalName: 'Désignation externe',
      declarationName: 'Désignation de déclaration',
      storageInstructions: 'Consignes de stockage',
      technicalProperties: 'Propriétés techniques',
      qualityProperties: 'Propriétés qualité',
      storageConditions: 'Conditions de stockage',
      foodProfile: 'Profil alimentaire optionnel',
      nutritionProfile: 'Profil nutritionnel optionnel',
      allergenInformation: 'Informations allergènes optionnelles',
      additiveInformation: 'Informations additifs optionnelles',
      extensionProfiles: 'Profils métier supplémentaires',
      conversions: 'Facteurs de conversion de l’article',
      dmsDocuments: 'Documents DMS et spécifications fournisseurs',
      changeReason: 'Motif de modification',
      reason: 'Justification',
    },
    actionDialog: {
      APPROVE: {
        title: 'Approuver les données de base',
        description:
          'L’approbation est traçable et exige un utilisateur différent du créateur et du demandeur.',
      },
      COPY: {
        title: 'Créer une nouvelle version',
        description:
          'Le contenu est copié dans un nouveau brouillon et les fournisseurs sont capturés à nouveau.',
      },
      ARCHIVE: {
        title: 'Archiver la version',
        description: 'La version reste entièrement traçable mais n’est plus utilisée activement.',
      },
    },
  },
  recipes: recipesFr,
  processRouting: processRoutingFr,
  batchScaling: batchScalingFr,
  declarations: declarationsFr,
  analysis: analysisFr,
} as const;
